export default {
    embassy: {
        formProp: 'embassy',
        form: {
            label: 'U.S. Diplomatic Mission (Embassy or Consulate) to',
            required: true
        },
        field: {
            size: 'small',
            mode: 'combobox',
            showSearch: true,
            showArrow: true,
            allowClear: true,
            placeholder: 'Select a country/embassy...',
            style: { width: '100%' }
        },
        options: []
    },
    streetAddress: {
        formProp: 'streetAddress',
        form: {
            label: 'Street Address',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Street address...'
        },
        validation: [
            'regex:^[0-9a-zA-Z\\s]*$:Only numbers, characters and spaces allowed.'
        ]
    },
    city: {
        formProp: 'city',
        form: {
            label: 'City',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'City...'
        },
        validation: [
            'regex:^[a-zA-Z ]*$:Only letters and spaces allowed.'
        ]
    },
    country: {
        formProp: 'country',
        form: {
            label: 'Country',
            required: true
        },
        field: {
            size: 'small',
            mode: 'combobox',
            showSearch: true,
            showArrow: true,
            allowClear: true,
            placeholder: 'Country...',
            style: { width: '100%' }
        },
        options: []
    },
    stateProvince: {
        formProp: 'stateProvince',
        form: {
            label: 'State / Province',
            required: true
        },
        field: {
            size: 'small',
            mode: 'combobox',
            showSearch: true,
            showArrow: true,
            allowClear: true,
            placeholder: 'State / Province ...',
            style: { width: '100%' }
        },
        options: []
    },
    postalZip: {
        formProp: 'postalZip',
        form: {
            label: 'Postal / ZIP code',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Postal / ZIP code ...'
        },
        validation: [ 'min-length:5', 'number' ]
    },
    phoneNumber: {
        formProp: 'phoneNumber',
        form: {
            label: 'Phone Number',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Phone number...'
        },
        validation: ['min-length:5', 'max-length:25', 'phone']
    }
}
